module.exports = __webpack_public_path__ + "static/media/wrong-ans.2687f447.mp3";